import { HttpService } from '../http.service'

const http = new HttpService()

interface Role {
  id: string
  name: string
  code: string
  permissions: string[]
}

export async function getWorkspace(
  workspace: string | undefined
): Promise<any[]> {
  if (!workspace) return []
  const response: any = await http.get(`auth/workspaces/${workspace}`)

  return response.data
}

export async function getRole(id: string): Promise<Role> {
  const response: any = await http.get(`auth/roles/${id}`)

  return response.data
}

export async function getRolesAssigned(roleIds: string[]): Promise<Role[]> {
  const roles: Role[] = []
  const promises = roleIds.map(
    async role => await http.get(`/auth/roles/${role}`)
  )
  const data = await Promise.all(promises)
  data.forEach(data => {
    const role: any = data.data
    roles.push({
      id: role.id,
      name: role.name,
      code: role.code,
      permissions: role?.permissions.map((p: any) => p.code)
    })
  })
  return roles
}

export async function createRole(data: any): Promise<boolean> {
  const response: any = await http.post('auth/roles', {
    name: data.name,
    code: data.code,
    permissionsIds: data.permissionsIds
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateRole(id: string, data: any): Promise<boolean> {
  const response: any = await http.put('auth/roles/' + id, {
    name: data.name,
    code: data.code,
    observation: data.observation,
    permissionsIds: data.permissionsIds
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteRole(id: string): Promise<boolean> {
  const response: any = await http.delete('auth/roles/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
